import './GoogleIcn.css';
import GoogleImage from '../../../assets/image/google.png';

const GoogleIcon = () => {
    return ( 
        <div className="googleicon">
            <img src={ GoogleImage } alt="google-icon" />
        </div>
     );
}
 
export default GoogleIcon;